import { SenseChat } from "logic/src/utils/error";
import { ELoginType } from "../objects/user/types";
import i18next from "../i18n";

export const AUTH_UID = "Uid";
export const USER_TOKEN = "USER_TOKEN";
// export const USER_INFO = "USER_INFO";
export const USER_NAME = "USER_NAME";
export const USER_PHONE = "USER_PHONE";
export const SESSION_ID = "SESSION_ID";
export const REQUEST_TOKEN = "Authorization";
export const MINDFUL_TIP = "MINDFUL_TIP";
export const POEM_TIP = "POEM_TIP";
export const CHAT_TYPE = "CHAT_TYPE";
export const SHOW_USER_WATERMARK = "SHOW_USER_WATERMARK";
export const WATERMARK_TEXT = "WATERMARK_TEXT";
export const MODEL_SWITCH = "MODEL_SWITCH";
export const USER_AREA_CODE = "USER_AREA_CODE";

export const SSO_LOGIN_ERR_TIPS: Record<string, string> = {
  "17": i18next.t("sensechat-109"), // "企业登录态已过期"
  "18": i18next.t("sensechat-110"), // "出错了，请重试"
};

export const AUTH_ERROR_TIP: Record<string, string> = {
  [SenseChat.Status.MobileFormatError]: i18next.t("sensechat-111"), // "手机号错误"
  [SenseChat.Status.SMSCodeError]: i18next.t("sensechat-90"), // "验证码错误"
  [SenseChat.Status.MobileNotExisted]: i18next.t("sensechat-91"), // "手机号不存在",
  [SenseChat.Status.UserNotExisted]: i18next.t("sensechat-112"), // "用户不存在，请先注册"
  [SenseChat.Status.WaitForApprove]: i18next.t("sensechat-179"), // "您的注册申请我们已经收到，请耐心等待审核"
  [SenseChat.Status.UserDisableError]: i18next.t("sensechat-113"), // "账号不可用",
  [SenseChat.Status.PasswordError]: i18next.t("sensechat-294"), // 手机号或密码错误
  [SenseChat.Status.SMSCodeBusyError]: "短信发送过于频繁，请1分钟后再试",
  [SenseChat.Status.SMSCodeHLimitError]:
    "超过每小时验证码最大发送次数，请稍后重试",
  [SenseChat.Status.SMSCodeDLimitError]:
    "超过每天验证码最大发送次数，请明天再试",
  [SenseChat.Status.OriginNotMatchError]: "旧密码输入错误",
  [SenseChat.Status.OriginModifySameError]: i18next.t("sensechat-297"), // "新密码不能和旧密码相同"
};

export const LOGIN_TYPE = [
  {
    value: ELoginType.sms_code,
    name: i18next.t("sensechat-292"), // 验证码登录
  },
  {
    value: ELoginType.password,
    name: i18next.t("sensechat-293"), // 密码登录
  },
];

export const VIDEO_DISABLE_TIP =
  "视频理解功能目前处于内测阶段，最多支持 5 次对话。如需继续使用，请删除历史对话后重新发起。";
